import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
import LoginView from '../views/LoginView.vue';
import MainDashboard from '../views/MainDashboard.vue';
import Scraping from '../views/Scraping.vue';
import ScrapingDetail from '../views/ScrapingDetail.vue';
import ScrapingDetail2 from '../views/ScrapingDetail2.vue';

import MapSearch from '../views/MapSearch.vue';
import MapDetail from '../views/MapDetail.vue';
import MapWrite from '../views/MapWrite.vue';
import UserAdmin from '../views/UserAdmin.vue';
import UserAdmin2 from '../views/UserAdmin2.vue';
import WorkAdmin from '../views/WorkAdmin.vue';
import SystemAdmin from '../views/SystemAdmin.vue';
import SystemAdmin1 from '../views/SystemAdmin1.vue';
import SystemAdmin2 from '../views/SystemAdmin2.vue';
import SystemAdmin3 from '../views/SystemAdmin3.vue';
import SystemAdmin4 from '../views/SystemAdmin4.vue';
import SystemAdmin5 from '../views/SystemAdmin5.vue';
import SystemAdmin6 from '../views/SystemAdmin6.vue';
import SystemAdmin7 from '../views/SystemAdmin7.vue';
import SystemAdmin8 from '../views/SystemAdmin8.vue';
import SystemAdmin9 from '../views/SystemAdmin9.vue';
import SystemAdmin9Detail from '../views/SystemAdmin9Detail.vue';
import SystemAdmin10 from '../views/SystemAdmin10.vue';
import SystemAdmin11 from '../views/SystemAdmin11.vue';
import SystemAdmin12 from '../views/SystemAdmin12.vue';
import SystemAdmin13 from '../views/SystemAdmin13.vue';
import SystemAdmin14 from '../views/SystemAdmin14.vue';
import SystemAdmin15 from '../views/SystemAdmin15.vue';
import SystemAdmin16 from '../views/SystemAdmin16.vue';
import SystemAdmin17 from '../views/SystemAdmin17.vue';
import SystemAdmin18 from '../views/SystemAdmin18.vue';
import SystemAdmin19 from '../views/SystemAdmin19.vue';
import SystemAdmin20 from '../views/SystemAdmin20.vue';
import LeadAdmin from '../views/LeadAdmin.vue';
import TotalSearch from '../views/TotalSearch.vue';
import PrintPage from '../views/PrintPage.vue';
import PrintPage2 from '../views/PrintPage2.vue';
import RentPrintPage from '../views/RentPrintPage.vue';
import RentPrintPage2 from '../views/RentPrintPage2.vue';
import UserDetail from '../views/UserDetail.vue';
import LeaseMapSearch from '../views/LeaseMapSearch.vue';
import LeaseUserAdmin from '../views/LeaseUserAdmin.vue';
import LeaseUserAdmin2 from '../views/LeaseUserAdmin2.vue';
import LeaseSearch from '../views/LeaseSearch.vue';
import LeaseAdmin from '../views/LeaseAdmin.vue';
import MessageBox from '../views/MessageBox.vue';
import LeaseMapDetail from '../views/LeaseMapDetail.vue';
import LeaseMapWrite from '../views/LeaseMapWrite.vue';
import LeaseUserDetail from '../views/LeaseUserDetail.vue';

import MapSearch2 from '../views/MapSearch2.vue';
import LeaseMapSearch2 from '../views/LeaseMapSearch2.vue';

import Post from '../views/Post.vue';
import PartnerCart from '../views/PartnerCart.vue';
import PartnerInbox from '../views/PartnerInbox.vue';
import MyProfile from '../views/MyProfile.vue';

// 2026-07 신규 기능 (사내 게시판 / 주간 업무 현황판 / 계약 관리 / 회의실·법인차 예약)
// 2026-09 Weekly Report (고객 매물 큐레이션 리포트). CM.
import ReportAdmin from '../views/ReportAdmin.vue';
import ReportEdit from '../views/ReportEdit.vue';
import PublicReport from '../views/PublicReport.vue';
import Board from '../views/Board.vue';
import BoardWrite from '../views/BoardWrite.vue';
import BoardDetail from '../views/BoardDetail.vue';
import WorkBoard from '../views/WorkBoard.vue';
import ContractAdmin from '../views/ContractAdmin.vue';
import ContractDetail from '../views/ContractDetail.vue';
import Booking from '../views/Booking.vue';

import Test1 from '../views/Test1.vue';

const routes = [
	{
		path: '/test1',
		name: 'Test1',
		component: Test1,
	},
	{
		path: '/',
		name: 'MainDashboard',
		component: MainDashboard,
	},
	{
		path: '/Post',
		name: 'Post',
		component: Post,
	},
	{
		path: '/Scraping',
		name: 'Scraping',
		component: Scraping,
	},
	{
		path: '/ScrapingDetail/:id',
		name: 'ScrapingDetail',
		component: ScrapingDetail,
	},
	{
		path: '/ScrapingDetail2/:id',
		name: 'ScrapingDetail2',
		component: ScrapingDetail2,
	},
	{
		path: '/LoginView',
		name: 'LoginView',
		component: LoginView,
		meta: { unauthorized: true },
	},
	{
		path: '/MapSearch',
		name: 'MapSearch',
		component: MapSearch,
	},
	{
		path: '/MapSearch2',
		name: 'MapSearch2',
		component: MapSearch2,
	},
	{
		path: '/MapDetail/:id',
		name: 'MapDetail',
		component: MapDetail,
	},
	{
		path: '/LeaseMapDetail/:id',
		name: 'LeaseMapDetail',
		component: LeaseMapDetail,
	},
	{
		path: '/PartnerCart',
		name: 'PartnerCart',
		component: PartnerCart,
	},
	{
		path: '/PartnerInbox',
		name: 'PartnerInbox',
		component: PartnerInbox,
	},
	{
		path: '/UserAdmin',
		name: 'UserAdmin',
		component: UserAdmin,
	},
	{
		path: '/UserAdmin2',
		name: 'UserAdmin2',
		component: UserAdmin2,
	},
	{
		path: '/UserDetail/:id',
		name: 'UserDetail',
		component: UserDetail,
		meta: { client: true },
	},
	{
		// 본인 정보 수정(전 사용자 자가 접근 — meta 가드 없음. 게스트도 헤더 '내 정보'에서 진입).
		path: '/MyProfile',
		name: 'MyProfile',
		component: MyProfile,
	},
	{
		path: '/WorkAdmin',
		name: 'WorkAdmin',
		component: WorkAdmin,
	},
	// CM: Weekly Report — 직원용 관리 화면(로그인 필요).
	{
		path: '/ReportAdmin',
		name: 'ReportAdmin',
		component: ReportAdmin,
	},
	{
		path: '/ReportEdit/:id',
		name: 'ReportEdit',
		component: ReportEdit,
	},
	// CM: 고객이 카톡으로 받은 링크로 여는 화면. **로그인 없이 열려야 하므로 unauthorized**.
	// 접근 통제는 링크 토큰(만료·회수)이 전부이고, 노출 자료는 발행 시점 스냅샷으로 한정된다
	// (backend/routes/publicReport.js · backend/util/reportSnapshot.util.js).
	{
		path: '/r/:token',
		name: 'PublicReport',
		component: PublicReport,
		meta: { unauthorized: true },
	},
	{
		path: '/SystemAdmin',
		name: 'SystemAdmin',
		component: SystemAdmin,
		meta: { master: true },
		children: [
			{
				path: '',
				component: SystemAdmin1,
				name: 'SystemAdmin1',
			},
			{
				path: 'SystemAdmin2',
				component: SystemAdmin2,
				name: 'SystemAdmin2',
			},
			{
				path: 'SystemAdmin3',
				component: SystemAdmin3,
				name: 'SystemAdmin3',
			},
			{
				path: 'SystemAdmin4',
				component: SystemAdmin4,
				name: 'SystemAdmin4',
			},
			{
				path: 'SystemAdmin5',
				component: SystemAdmin5,
				name: 'SystemAdmin5',
			},
			{
				path: 'SystemAdmin6',
				component: SystemAdmin6,
				name: 'SystemAdmin6',
			},
			{
				path: 'SystemAdmin7',
				component: SystemAdmin7,
				name: 'SystemAdmin7',
			},
			{
				path: 'SystemAdmin8',
				component: SystemAdmin8,
				name: 'SystemAdmin8',
			},
			{
				path: 'SystemAdmin9',
				component: SystemAdmin9,
				name: 'SystemAdmin9',
			},
			{
				path: 'SystemAdmin9Detail/:id',
				component: SystemAdmin9Detail,
				name: 'SystemAdmin9Detail',
			},
			{
				path: 'SystemAdmin10',
				component: SystemAdmin10,
				name: 'SystemAdmin10',
			},
			{
				path: 'SystemAdmin11',
				component: SystemAdmin11,
				name: 'SystemAdmin11',
			},
			{
				path: 'SystemAdmin12',
				component: SystemAdmin12,
				name: 'SystemAdmin12',
			},
			{
				path: 'SystemAdmin13',
				component: SystemAdmin13,
				name: 'SystemAdmin13',
			},
			{
				path: 'SystemAdmin14',
				component: SystemAdmin14,
				name: 'SystemAdmin14',
			},
			{
				path: 'SystemAdmin15',
				component: SystemAdmin15,
				name: 'SystemAdmin15',
			},
			{
				path: 'SystemAdmin16',
				component: SystemAdmin16,
				name: 'SystemAdmin16',
			},
			{
				path: 'SystemAdmin17',
				component: SystemAdmin17,
				name: 'SystemAdmin17',
			},
			{
				// CY: 자동보류 제외 관리(제외 현황·직원 한도·제외 사유). master 전용(위 meta.master).
				path: 'SystemAdmin18',
				component: SystemAdmin18,
				name: 'SystemAdmin18',
			},
			{
				// CZ: 주간 KPI 기준값·직원별 신규 매수배정(PASS/HOLD·순번·일시정지·부재). master 전용(위 meta.master).
				path: 'SystemAdmin19',
				component: SystemAdmin19,
				name: 'SystemAdmin19',
			},
			{
				// DC: 팀 관리(팀장 지정·팀원 이동·위클리 열람범위). master 전용(위 meta.master).
				path: 'SystemAdmin20',
				component: SystemAdmin20,
				name: 'SystemAdmin20',
			},
		],
	},
	// ── 2026-07 신규 기능 ────────────────────────────────────────────────────
	// 전부 직원 전용. 백엔드 adminGuard 가 /board·/workboard·/contract·/booking 을
	// 제휴기관 게스트에게 403 으로 막으므로, 화면 진입도 아래 beforeEach 에서 막는다
	// (열지 못하는 화면에서 alert 폭탄이 뜨는 것을 방지).
	{
		path: '/Board',
		name: 'Board',
		component: Board,
	},
	{
		// :id? — 신규 작성(id 없음)과 수정(id 있음)이 같은 화면이고, 호출부가 두 형태를 모두 쓴다
		// (목록 '글쓰기' 는 params 없이, 상세 '수정' 은 params.id 로 push).
		path: '/BoardWrite/:id?',
		name: 'BoardWrite',
		component: BoardWrite,
	},
	{
		path: '/BoardDetail/:id',
		name: 'BoardDetail',
		component: BoardDetail,
	},
	{
		path: '/WorkBoard',
		name: 'WorkBoard',
		component: WorkBoard,
	},
	{
		// CZ: 신규 매수문의 등록·순번 배정. 고객 연락처를 다루는 관리 화면이다.
		// DC: master 와 매수배정 담당(kpi_member.lead_manage)이 쓴다. 담당 여부는 화면이 서버(/lead/meta)에 묻고
		// 아니면 대시보드로 보낸다(라우터는 그 값을 모른다). 서버도 /lead/* 쓰기를 같은 기준으로 막는다.
		path: '/LeadAdmin',
		name: 'LeadAdmin',
		component: LeadAdmin,
	},
	{
		path: '/ContractAdmin',
		name: 'ContractAdmin',
		component: ContractAdmin,
	},
	{
		path: '/ContractDetail/:id',
		name: 'ContractDetail',
		component: ContractDetail,
	},
	{
		path: '/Booking',
		name: 'Booking',
		component: Booking,
	},
	{
		path: '/MapWrite/:id',
		name: 'MapWrite',
		component: MapWrite,
	},
	{
		path: '/LeaseMapWrite/:id',
		name: 'LeaseMapWrite',
		component: LeaseMapWrite,
	},
	{
		path: '/TotalSearch',
		name: 'TotalSearch',
		component: TotalSearch,
	},
	{
		path: '/PrintPage',
		name: 'PrintPage',
		component: PrintPage,
	},
	{
		path: '/PrintPage2',
		name: 'PrintPage2',
		component: PrintPage2,
	},
	{
		path: '/RentPrintPage',
		name: 'RentPrintPage',
		component: RentPrintPage,
	},
	{
		path: '/RentPrintPage2',
		name: 'RentPrintPage2',
		component: RentPrintPage2,
	},
	{
		path: '/LeaseMapSearch',
		name: 'LeaseMapSearch',
		component: LeaseMapSearch,
	},
	{
		path: '/LeaseMapSearch2',
		name: 'LeaseMapSearch2',
		component: LeaseMapSearch2,
	},
	{
		path: '/LeaseUserAdmin',
		name: 'LeaseUserAdmin',
		component: LeaseUserAdmin,
	},
	{
		path: '/LeaseUserAdmin2',
		name: 'LeaseUserAdmin2',
		component: LeaseUserAdmin2,
	},
	{
		path: '/LeaseUserDetail/:id',
		name: 'LeaseUserDetail',
		component: LeaseUserDetail,
		meta: { rent_client: true },
	},
	{
		path: '/LeaseSearch',
		name: 'LeaseSearch',
		component: LeaseSearch,
	},
	{
		path: '/LeaseAdmin',
		name: 'LeaseAdmin',
		component: LeaseAdmin,
	},
	{
		path: '/MessageBox',
		name: 'MessageBox',
		component: MessageBox,
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach(async (to, from, next) => {
	const storeToken = store.getters.getToken;

	// 제휴기관(은행/기업) 게스트(getPartnerGuest = guest && institution)는 직원 전용 화면 진입 차단.
	// 일반 게스트(내부 직원의 데모용 guest 체크)·직원은 영향 없음. 매매작업(WorkAdmin)
	// + 시스템관리(meta.master)·임대고객 상세(meta.rent_client) → 대시보드 리다이렉트.
	// 단, 매매(매수)고객 목록(UserAdmin)·상세(UserDetail)·브리핑 대상 고객 선택 팝업(UserAdmin2)은
	// 게스트가 자기 기관 고객을 관리하는 화면이므로 허용한다(데이터는 백엔드 SP·소유권 가드로
	// 기관·본인 격리). UserAdmin2 는 매매검색(TotalSearch)의 "브리핑 대기 물건 저장" → window.open 대상.
	// 임대(LeaseUserAdmin/LeaseUserAdmin2/LeaseAdmin)는 게스트 임대고객 관리 범위 밖이라 계속 차단.
	const PARTNER_GUEST_ALLOW = ['UserAdmin', 'UserAdmin2', 'UserDetail', 'MyProfile'];
	if (
		store.getters.getPartnerGuest &&
		!PARTNER_GUEST_ALLOW.includes(to.name) &&
		(to.matched.some(record => record.meta.master || record.meta.client || record.meta.rent_client) ||
			[
				'WorkAdmin', 'LeaseUserAdmin', 'LeaseUserAdmin2', 'LeaseAdmin',
				// 2026-07 신규 — 사내 정보(게시판·실적·계약·예약). 백엔드도 403 으로 막는다.
				'Board', 'BoardWrite', 'BoardDetail', 'WorkBoard', 'ContractAdmin', 'ContractDetail', 'Booking',
				// CM: Weekly 관리 화면. 백엔드도 /report 를 STAFF_ONLY_PREFIXES 로 막는다.
				'ReportAdmin', 'ReportEdit',
				// DC: 신규 매수문의(관리자·매수배정 담당). 백엔드도 /lead 를 STAFF_ONLY_PREFIXES 로 막는다.
				'LeadAdmin',
			].includes(to.name))
	) {
		alert('접근권한이 없습니다.');
		return next({ name: 'MainDashboard' });
	}

	if (to.matched.some(record => record.meta.unauthorized)) {
		return next();
	} else if (to.matched.some(record => record.meta.master)) {
		const level = store.getters.getUserInfo.mem_type;
		if ('master' == level) {
			return next();
		}
	} else if (to.matched.some(record => record.meta.client)) {
		const level = store.getters.getUserInfo.mem_type;
		// 제휴기관 게스트는 매매고객 상세(UserDetail) 접근 허용 — 자기 기관 고객 관리용.
		// 다른 고객 cid 는 백엔드 소유권 가드(institution+본인)가 403 으로 차단한다.
		if ('master' == level || 'Y' == store.getters.getUserInfo.client_view || store.getters.getPartnerGuest) {
			return next();
		}
		alert('접근권한이 없습니다.');
		window.close();
		return;
	} else if (to.matched.some(record => record.meta.rent_client)) {
		const level = store.getters.getUserInfo.mem_type;
		if ('master' == level || 'Y' == store.getters.getUserInfo.rent_client_view) {
			return next();
		}
		alert('접근권한이 없습니다.');
		window.close();
		return;
	} else if (storeToken) {
		// 게스트모드는 편집 페이지(MapWrite/LeaseMapWrite) 직접 URL 접근 차단 — 입금가 입력 input 노출 +
		// 직원 전용 CRM 읽기(getMgrLog/getClientLog 등) 호출에 따른 403 alert 폭탄 방지 (매매/임대 대칭)
		if (store.getters.getGuest && (to.name === 'MapWrite' || to.name === 'LeaseMapWrite')) {
			alert('접근권한이 없습니다.');
			return next({ name: 'MainDashboard' });
		}
		// 제휴 게스트(은행직원) 전용 — 담은 물건 페이지
		if (to.name === 'PartnerCart' && !(store.getters.getGuest && store.getters.getInstitution)) {
			alert('접근권한이 없습니다.');
			return next({ name: 'MainDashboard' });
		}
		// 위온어스 직원 전용 — 수신함 (게스트 차단)
		if (to.name === 'PartnerInbox' && store.getters.getGuest) {
			alert('접근권한이 없습니다.');
			return next({ name: 'MainDashboard' });
		}
		// CM: Weekly 는 '개발중' 게이트가 켜져 있으면 어드민(master) 외에는 막는다(2026-09-08).
		// 일반 직원은 전원 mem_type='admin' 이므로 'master' 로 판정해야 실제로 막힌다.
		// DE(2026-10-29): 게이트가 꺼져 있어도 **사용 권한**이 있는 직원만 들어온다(기본은 팀장, 관리자가 팀 관리에서 부여·회수).
		// 게이트와 권한은 서버가 정한다 — 진입할 때마다 물어보고 답이 온 뒤에 판정한다(모르면 막는 쪽).
		// 백엔드도 /admin/api/report/* 를 같은 기준으로 403 으로 막는다(middleware/weeklyGate.js, routes/report.js).
		if (['ReportAdmin', 'ReportEdit'].includes(to.name)) {
			// 값이 있어도 **매번 다시 본다** — 화면을 열어 둔 채 서버에서 게이트를 끄면,
			// 캐시된 옛 값 때문에 계속 막힌다(Codex 리뷰). 요청은 boolean 하나짜리다.
			//
			// **반드시 await 한다.** 이 가드는 async 라서, 가드가 끝난 뒤에 next() 를 부르면
			// vue-router 가 "next 가 불리지 않았다" 로 보고 'Invalid navigation guard' 를 던져
			// 이동을 통째로 취소한다 — 화면은 그대로 있고 오류만 콘솔에 남는다(실측).
			try {
				await store.dispatch('fetchWeeklyGate');
			} catch (e) { /* 못 물어보면 막는 쪽으로 판정된다(getWeeklyBlocked) */ }
			if (store.getters.getWeeklyBlocked) {
				const why = store.getters.getWeeklyBlockReason;
				alert(why === 'dev' ? '개발중입니다!'
					: why === 'unknown' ? 'Weekly 사용 권한을 확인하지 못했습니다. 잠시 뒤 다시 열어 주세요.'
						: 'Weekly 사용 권한이 없습니다. 관리자에게 요청해 주세요.');
				return next({ name: 'MainDashboard' });
			}
			return next();
		}
		return next();
	}

	// alert('로그인 해주세요');
	return next('/LoginView');
});

// 화면 이동이 끝날 때마다 Weekly 게이트 상태를 새로 본다(boolean 하나짜리 요청).
// 이게 없으면 서버에서 게이트를 끈 뒤에도 **이미 열어 둔 화면**의 메뉴·버튼이 돌아오지 않는다
// (헤더는 페이지를 새로 열 때만 만들어지기 때문 — Codex 리뷰).
router.afterEach(() => {
	if (store.getters.getToken) store.dispatch('fetchWeeklyGate');
});

export default router;
